import classNames from "classnames"
import React from "react"

import { CELL_TEXT_CLASSSES } from "./CellData"
import { getThemeColor } from "./utils"
import Typography from "../../../elements/V2/Typography"

type PriceCellProps = {
  price: number
  theme: "light" | "dark"
  detailed?: boolean
  priceSubScript?: string
  priceSideScript?: string
  promotionSavings?: number
  showPromotion?: boolean
  topText?: string
}

const PriceCell = ({
  price,
  theme,
  detailed = false,
  priceSubScript,
  priceSideScript,
  promotionSavings,
  showPromotion,
  topText,
}: PriceCellProps) => {
  if (!detailed) {
    return (
      <Typography
        font="grotesk"
        weight="medium"
        color={getThemeColor(theme)}
        size="lead-lg"
        text={"R" + price}
        className={CELL_TEXT_CLASSSES}
      />
    )
  }

  return (
    <div className="flex flex-col items-start gap-12">
      {((showPromotion && promotionSavings && promotionSavings > 0) ||
        topText) && (
        <Typography
          font="grotesk"
          weight="book"
          color={getThemeColor(theme)}
          size="body-sm"
          text={
            showPromotion && promotionSavings && promotionSavings > 0
              ? "Save R" + promotionSavings
              : topText || ""
          }
          className={classNames(CELL_TEXT_CLASSSES, "opacity-70")}
          leadingNone
        />
      )}
      <div className="flex place-items-baseline gap-2">
        <Typography
          font="grotesk"
          weight="medium"
          color={getThemeColor(theme)}
          size="lead-lg"
          text={"R" + price}
          className={CELL_TEXT_CLASSSES}
          leadingNone
        />
        {priceSideScript && (
          <Typography
            font="grotesk"
            weight="medium"
            color={getThemeColor(theme)}
            size="subscript-sm"
            text={priceSideScript}
            className={CELL_TEXT_CLASSSES}
            leadingNone
          />
        )}
      </div>
      {priceSubScript && (
        <Typography
          font="grotesk"
          weight="book"
          color={getThemeColor(theme)}
          size="body-sm"
          text={priceSubScript}
          className={CELL_TEXT_CLASSSES}
          leadingNone
        />
      )}
    </div>
  )
}

export default PriceCell
